import { Controller, FieldValues } from 'react-hook-form'
import { RhfProps } from './rhf.props'
import { InputField, InputFieldProps } from '../input-field'
export type InputFieldRhfProps<T extends FieldValues = FieldValues> = InputFieldProps & RhfProps<T>

export function InputFieldRhf<T extends FieldValues = FieldValues>({
  name,
  control,
  rules = {},
  defaultValue,
  showRequired = true,
  showHelperText,
  ...inputProps
}: InputFieldRhfProps<T>) {
  if (inputProps.required) {
    rules.required = 'This field is required'
  }
  return (
    <Controller<T>
      name={name}
      rules={rules}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value, onBlur }, fieldState: { error, isDirty } }) => (
        <InputField
          {...inputProps}
          value={value ?? ''}
          onBlur={onBlur}
          error={!!error}
          onChangeText={onChange}
          helperText={error ? error.message : inputProps.helperText}
          showRequired={showRequired}
          showHelperText={showHelperText}
          isDirty={isDirty}
        />
      )}
    />
  )
}
